// extracted by mini-css-extract-plugin
export var container = "_4f-0";
export var fallback = "_4f-5";
export var fallbackIcon = "_4f-6";
export var hidden = "_4f-2";
export var image = "_4f-3";
export var loaded = "_4f-4";
export var placeholder = "_4f-1";